import {secureFetch} from "./authService";
import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from "./constants";

export function getPlayerMediaList(query) {
    let url = API_BASE_URL + '/player/media?';

    if (query) {
        const {page = 0, size = PAGINATION_DEFAULT_LIMIT, companyId, folderId} = query;

        if (size) {
            url = url + `&size=${size}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }

        if (companyId) {
            url = url + `&companyId=${companyId}`;
        }

        if (folderId) {
            url = url + `&folderId=${folderId}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function uploadPlayerMedia(media) {
    return secureFetch(API_UPLOAD_URL + '/player/media', {
        method: 'POST',
        body: media
    }, {});
}

export function updatePlayerMedia(media) {
    return secureFetch(API_BASE_URL + `/player/media/${media.id}`, {
        method: 'PUT',
        body: JSON.stringify(media)
    });
}

export function deletePlayerMedia(mediaId) {
    return secureFetch(API_BASE_URL + `/player/media/${mediaId}`, {
        method: 'DELETE'
    });
}


// WEBPACK FOOTER //
// ./src/helpers/playerMediaService.js